export const isValidReturnUrl = (url) => {
  try {
    if (!url.startsWith('/') || url.startsWith('//')) {
      return false;
    }

    const allowedPaths = [
      '/dashboard',
      '/v2/upcoming-event',
      '/v2/upcoming-events',
      '/v2/finances',
      '/v2/event-drafts',
      '/referral',
      '/v2/create-event/type',
    ];

    return allowedPaths.some(path => url.startsWith(path));
  } catch {
    return false;
  }
};